import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdatePageRequest } from "@shopexperts/shared";

interface UpdatePageParams {
  id: number;
  schemaId?: number;
  data: UpdatePageRequest;
}

export function useUpdatePage() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: ({ id, data }: UpdatePageParams) => 
      api.admin.pages.updatePage({ params: { id }, body: data }),
    onSuccess: (_, variables) => {
      // Invalidate pages list for this schema
      if (variables.schemaId) {
        queryClient.invalidateQueries({ queryKey: ['admin', 'pages', { schema_id: variables.schemaId }] });
      }
      // Also invalidate general pages queries
      queryClient.invalidateQueries({ queryKey: ['admin', 'pages'] });
      
      toaster.create({
        title: "Page updated successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useUpdatePage] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while updating the page.';
      
      toaster.create({
        title: "Failed to update page",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
